import React from "react";
import API_BASE_URL from "../config/apiConfig";
import { useAuth } from "../context/AuthProvider";

type Props = {
  start_time: string; // ISO: 2026-02-03T00:00:00
  end_time: string;   // ISO: 2026-02-03T23:59:59.999
};

const ExportMedicScores: React.FC<Props> = ({ start_time, end_time }) => {
  const { token } = useAuth();

  const isoToDate = (iso: string) => (iso || "").split("T")[0];

  const download = async () => {
    const url =
      `${API_BASE_URL}/medic-score-config/export-table` +
      `?start_time=${encodeURIComponent(start_time)}` +
      `&end_time=${encodeURIComponent(end_time)}`;

    const r = await fetch(url, {
      headers: { Authorization: `Bearer ${token}` },
    });

    if (!r.ok) {
      const data = await r.json().catch(() => ({}));
      alert(data?.detail || "Nu s-a putut genera exportul.");
      return;
    }

    const blob = await r.blob();
    const a = document.createElement("a");
    const href = window.URL.createObjectURL(blob);
    a.href = href;

    const sd = isoToDate(start_time);
    const ed = isoToDate(end_time);
    a.download = `acoperire_medici_${sd}_${ed}.xlsx`;

    document.body.appendChild(a);
    a.click();
    a.remove();
    window.URL.revokeObjectURL(href);
  };

  return (
    <div style={{ display: "flex", gap: 8 }}>
      <button className="primary-btn" onClick={download}>
        Export Excel
      </button>
    </div>
  );
};

export default ExportMedicScores;